var styles = {"box":"FormSelect_box_1tc43_1","box__inner":"FormSelect_box__inner_1tc43_4","label":"FormSelect_label_1tc43_9","required":"FormSelect_required_1tc43_34","input__wrapper":"FormSelect_input__wrapper_1tc43_37","error":"FormSelect_error_1tc43_47","absolute":"FormSelect_absolute_1tc43_56","sm":"FormSelect_sm_1tc43_69"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
